import {Helmet} from 'react-helmet';
import Contact from "../../Page/contact";



const faqsContent ={
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What website design services do you offer in Delhi?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "We offer custom website design, mobile‑responsive layouts, CMS integration (WordPress/Joomla), e‑commerce development, SEO optimization, and post‑launch technical support."
      }
    },
    {
      "@type": "Question",
      "name": "How much does a basic website cost in Delhi?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Informational websites typically start from ₹15,000–₹25,000 depending on page count and design complexity. E‑commerce or custom solutions are quoted after understanding your goals."
      }
    },
    {
      "@type": "Question",
      "name": "How long does it take to complete a website project in Delhi?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Standard business websites are usually delivered in 4–6 weeks, while e‑commerce platforms or custom projects may take 8–12 weeks, depending on scope."
      }
    },
    {
      "@type": "Question",
      "name": "Will my website be mobile‑friendly and SEO‑optimized?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes—sites are built with a mobile‑first approach, fully responsive, and optimized using clean code, fast load times, meta tags, structured data, and image compression."
      }
    },
    {
      "@type": "Question",
      "name": "Can I manage content myself after launch?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Absolutely! You'll receive a user-friendly CMS-powered site (WordPress or Joomla) with training so you can update content independently."
      }
    },
    {
      "@type": "Question",
      "name": "Do you offer maintenance and support after the site goes live?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes—we offer monthly or annual maintenance plans covering updates, backups, security patches, plugin/theme upgrades, and technical assistance."
      }
    },
    {
      "@type": "Question",
      "name": "Do you integrate my brand’s logo and colours into the design?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Certainly—we seamlessly incorporate your branding elements—logo, colour palette, typography, and style guidelines—for a cohesive and professional look."
      }
    },
    {
      "@type": "Question",
      "name": "Can you help with domain registration and hosting setup?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Definitely—we can register your domain, set up hosting (shared, VPS, or cloud), or configure your existing provider for a seamless deployment."
      }
    },
    {
      "@type": "Question",
      "name": "How do you monitor website performance and improvements?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "We integrate Google Analytics and Search Console, track load times and SEO metrics, run audits, and provide performance reports with actionable recommendations."
      }
    },
    {
      "@type": "Question",
      "name": "What is your process for starting a website project in Delhi?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Our process includes: discovery call → proposal & quote → content planning & wireframes → mockups → development → testing & revisions → launch → training & ongoing support."
      }
    }
  ]
}

function App1() {
  return (
   <>
 <Helmet>
  <script type="application/ld+json">
          {JSON.stringify(faqsContent)}
        </script>
<title>Pankaj | Website Designer In Delhi</title>
<meta name="description" content="Top website designer in Delhi. Get a modern website design with me in low cost. Elevate your online presence today!"/>
<meta name="keywords" content="website designer in delhi, website designer in delhi ncr, freelance website designer in delhi, website designer in laxmi nagar, best website designer in delhi, website designer in rohini, best freelance website designer in delhi, ecommerce website designer in dwarka, top website designers in delhi, website developer near me"/>
<meta property="og:title" content="Pankaj | Website Designer In Delhi" />
<meta property="og:description" content="Top Website Designer In Delhi. Get a modern website design with me in low cost. Elevate your online presence today!" />
<meta property="og:site_name" content="Pankaj | Website Designer In Delhi" />
<meta property="og:url" content="https://www.pankj.com/website-designer-in-delhi"/>
<meta property="og:image" content="https://www.pankj.com/assets/img/dpnew.jpg"/>
<meta name="twitter:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />
<meta name="twitter:title" content="Pankaj | Website Designer In Delhi" />
<meta name="twitter:description" content="Top website designer in Delhi. Get a modern website design with me in low cost. Elevate your online presence today!" />
<link rel="canonical" href="https://www.pankj.com/website-designer-in-delhi" />
        </Helmet>
 <section id="hero" className="hero d-flex align-items-center fixedabove">
   <video
                className="mainsliderbg"
                autoPlay
                muted
                loop={true} style={{width:'100%'}}>
                <source src="assets/img/bg.mp4" type="video/mp4" />
                <source src="bg.ogg" type="video/ogg" />
  </video>
<div className="mainsliderbg">
     <div className="container-fluid">
      <div className="row">
        <div className="col-lg-6 d-flex flex-column">
            <img src="../assets/img/thyear.webp" className="imgsz" alt="Website Designer" />
  <h1 className="multiple_effects fzsml" id="text3d">Website Designer In Delhi</h1>
          <div className="content_sec" data-aos="fade-up" data-aos-delay="400">Take a look at some of my works, and if you like them, feel free to contact me.</div>
  <div data-aos="fade-up" data-aos-delay="600">
            <div className="text-center text-lg-start">
              <a href="https://api.whatsapp.com/send?phone=917838704822&text=Hello%20Pankaj" target="_blank" className="btn-get-started scrollto d-inline-flex align-items-center justify-content-center align-self-center">
                <span>WhatsApp</span>
                <i className="bi bi-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-6 hero-img" data-aos="zoom-out" data-aos-delay="200">
              <div className="img-area">
      <div className="inner-area">
        <img src="../assets/img/pks2.webp" alt="Website Designer" />
      </div>
    </div>
        </div>
      </div>
    </div> 
</div>
  </section>   

    <main id="main">
  <section id="pageContent" className="pageContent">

      <div className="container" data-aos="fade-up">
        <header className="section-header">
          <h2>Website Designer in Delhi</h2>
        </header>

        <div className="row">
          <div className="col-lg-12">
Welcome to Pankaj's Web Design Services! As a professional website designer based in the bustling city of Delhi, I am dedicated to helping businesses and individuals establish a strong online presence. With a keen eye for design and a focus on functionality, I create websites that not only look great but also perform exceptionally well.
<h3>My Services:</h3>
<h4><strong>Custom Website Design</strong></h4>
Your website should reflect your unique brand identity. I specialize in crafting custom websites tailored to your specific needs, whether it's a corporate site, a creative portfolio, or a personal blog. My designs are aesthetically pleasing and strategically structured to enhance user engagement.
<h4><strong>E-Commerce Solutions</strong></h4>
Looking to sell online? I provide comprehensive e-commerce solutions that make it easy for you to set up and manage your online store. My e-commerce websites come equipped with secure payment gateways, intuitive navigation, and features designed to boost conversions and enhance customer satisfaction.
<h4><strong>Responsive Web Development</strong></h4>
In today’s digital landscape, having a mobile-friendly website is essential. I ensure that all websites I create are fully responsive, adapting seamlessly to various devices, including desktops, tablets, and smartphones. This guarantees a consistent user experience for all visitors.
<h4><strong>SEO-Friendly Websites</strong></h4>
Visibility is key in the online world. I implement SEO best practices during the design process to improve your website's search engine rankings. This includes optimizing your site's structure, content, and images, helping you attract organic traffic and reach your target audience effectively.
<h4><strong>Website Redesign</strong></h4>
If your current website is outdated or not achieving the desired results, I offer website redesign services to revitalize its look and functionality. I focus on modernizing the design, enhancing performance, and aligning the website with your current business objectives.
<h4><strong>Content Management Systems (CMS)</strong></h4>
I utilize popular CMS platforms like WordPress, which empower you to manage your website content easily. With a user-friendly interface, you can make updates and changes without requiring technical expertise, giving you full control over your site.
<h4><strong>Maintenance &amp; Support</strong></h4>
After your website goes live, I provide ongoing maintenance and support services to ensure everything operates smoothly. From routine updates to troubleshooting issues, I am here to assist you whenever you need help.
<h4><strong>Digital Marketing &amp; SEO Services</strong></h4>
In addition to web design, I offer basic digital marketing services to enhance your online visibility. Whether it’s social media marketing, email campaigns, or content strategies, I can help you connect with your audience and promote your brand effectively.
<h3>Why Choose Me?</h3>
<ul>
  <li><strong>Experience</strong>: With over a decade in the web design industry, I deliver high-quality results tailored to your needs.</li>
  <li><strong>Client-Centric Approach</strong>: I prioritize your vision and goals, ensuring that the final product exceeds your expectations.</li>
  <li><strong>Affordable Pricing</strong>: Quality web design should be accessible. I offer competitive pricing tailored to fit your budget.</li>
  <li><strong>Timely Delivery</strong>: I respect your deadlines and am committed to delivering your project on time without compromising quality.</li>
</ul>
Let’s work together to create an impressive website that captures your brand essence and engages your audience. Contact me today for a consultation and a free quote!
<h2>Frequently Asked Questions</h2>

<h4>1. What services do you offer as a website designer?</h4>
<p>I offer a variety of services, including custom website design, e-commerce solutions, responsive web development, SEO-friendly websites, website redesign, CMS implementation, ongoing maintenance and support, and basic digital marketing services.</p>

<h4>2. How long does it take to design and develop a website?</h4>
<p>The time required to design and develop a website depends on its complexity and your specific requirements. Generally, a basic website takes about 2-4 weeks, while more complex projects may take longer. I will provide you with a detailed timeline during our initial consultation.</p>

<h4>3. Will my website be mobile-friendly?</h4>
<p>Yes! All websites I create are fully responsive, ensuring they look great and function well on all devices, including desktops, tablets, and smartphones. This guarantees an excellent user experience for all visitors.</p>

<h4>4. Can you help with SEO for my website?</h4>
<p>Absolutely! I incorporate SEO best practices during the website design process to improve your site’s visibility on search engines. This includes optimizing your site’s structure, content, and images to attract organic traffic.</p>

<h4>5. Do you provide ongoing support after the website is launched?</h4>
<p>Yes, I offer ongoing maintenance and support services to ensure your website runs smoothly post-launch. This includes regular updates, troubleshooting, and assistance with any issues that may arise.</p>

<h4>6. How do I update my website after it’s launched?</h4>
<p>If you choose to use a Content Management System (CMS) like WordPress, you will be able to update your website content independently. I will provide you with training on how to manage your site, and I'm always available for assistance with other changes or updates.</p>

<h4>7. What is the cost of your website design services?</h4>
<p>The cost of website design services varies based on the project's complexity, features, and your specific needs. I offer a free quote after discussing your project in detail to ensure a solution that fits your budget.</p>

<h4>8. Can you redesign my existing website?</h4>
<p>Yes, I offer website redesign services to refresh and improve your current site. This may include updating the design, enhancing functionality, and optimizing for better performance and user experience.</p>

<h4>9. How do we get started on a project?</h4>
<p>To get started, simply contact me through my website or reach out via email or phone. We’ll schedule a consultation to discuss your project goals, timeline, and budget, allowing us to create a tailored plan for your website.</p>

<h4>10. Why should I choose you as my website designer?</h4>
<p>With over a decade of experience, a client-focused approach, and a commitment to delivering high-quality results on time, I am dedicated to helping you create a website that meets your needs and exceeds your expectations. Your satisfaction is my top priority!</p>


          </div>
        </div>
      </div>

    </section>
 <Contact />
    </main>
    </>
  );
}
export default App1;
